<div class="sidebar">
	<app-sidebar-header [title]="'voucherPromocodeSidebar.title.voucherAndPromoCodes'  | ibeadmin | async"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>

		<div class="voucher-or-promocode">

			<div class="voucher-or-promocode__content">
				<p>{{'voucherPromocodeSidebar.text.redeemPromocodeVoucher'  | ibeadmin | async}}</p>
				<a [attr.aria-label]="'voucherPromocodeSidebar.aria.readVouchers'  | ibeadmin | async" class="link link--external" (click)="INDRA_redirectToUrl('externalURLs.voucherTermsUrl')" href="javascript:;" role="button">
					{{'voucherPromocodeSidebar.text.vouchersPromocodesTerms' | ibeadmin | async }}
				</a>
			</div>

			<div class="voucher-or-promocode__vouchers">
				<div class="divider"></div>

				<div class="voucher" *ngFor="let discount of bookedTripDiscounts; let i = index">

					<div class="voucher__content">
						<app-svg aria-hidden="true" [alt]="'Discount icon'" class="voucher__content_icon" svg="sprite.svg#status--discount"></app-svg>
						<div class="voucher__content-text">
							<h3 class="title-h3">{{'voucherPromocodeSidebar.text.discountApplied'  | ibeadmin | async}} - {{discount?.id}}</h3>
							<p *ngIf="discount?.type === 'Voucher'">
								{{'voucherPromocodeSidebar.text.discountAppliedSaving'  | ibeadmin | async}} <span class="bold">{{discount?.amount.toString() | indracurrency }} {{ currency }}</span> {{'voucherPromocodeSidebar.text.discountAppliedSaving2'  | ibeadmin | async}}
							</p>
							<p *ngIf="discount?.type === 'Promocode'">
								{{'voucherPromocodeSidebar.text.youArePaying'  | ibeadmin | async}} 
								<span class="bold">
									{{discount?.amount.toString() | indracurrency }} {{ discount?.currency !== 'FFP' ? currency : 'M' }} {{'voucherPromocodeSidebar.text.less'  | ibeadmin | async}}
								</span> {{'voucherPromocodeSidebar.text.discountAppliedSaving2'  | ibeadmin | async}}
							</p>

							<!-- Remaining info -->
							<!-- <p>
								No ammount is remaining on this voucher (VCHGV 04789000898989898).
							</p>
							<p>
								There are 100 EUR remaining on this voucher (VCHGV 04789000898989898). <br>
								You can use the remaining ammout in future purchases.
							</p> -->

						</div>
					</div>

				</div>

			</div>
		</div>

		<div class="sidebar-flight-text">
			<p><a class="link extras-feature__link" attr.aria-label="{{'voucherPromocodeSidebar.text.closeDialog'  | ibeadmin | async}}" (click)="TAP_handleClose()" href="javascript:;"
					role="button">{{'voucherPromocodeSidebar.text.closethisWindow'  | ibeadmin | async}}</a></p>
		</div>
	</div>

	<div #sidebar__footer class="sidebar__footer "></div>
</div>
